// =========================
// CONTACT PAGE – FULL FIXED
// =========================
import React, { useEffect } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import "../Pages/Contact.css";
import { Helmet } from "react-helmet";

// AOS IMPORT
import AOS from "aos";
import "aos/dist/aos.css";

export default function Contact() {

  // 🔥 FIX FOR BLANK PAGE – AOS MUST BE INITIALIZED
  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true,
      easing: "ease-out",
    });
    window.scrollTo(0, 0); // FIX PAGE NOT SHOWING UNTIL SCROLL
  }, []);

  return (
    <>
<Helmet>
  <title>Contact Sri Rajalakshmi Travels | Van & Car Booking Aruppukottai</title>

  <meta
    name="description"
    content="Call or WhatsApp Sri Rajalakshmi Travels for van rental, car rental, tour booking and airport pickup in Aruppukottai. 24/7 customer support."
  />

  <meta
    name="keywords"
    content="Aruppukottai travels contact, van booking contact, car rental contact Aruppukottai, travels whatsapp number Aruppukottai"
  />

  <link rel="canonical" href="https://srirajalakshmitravels.in/contact" />


  {/* ✅ TravelAgency Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "TravelAgency",
      name: "Sri Rajalakshmi Travels",
      image: "https://srirajalakshmitravels.com/static/media/SRILOGO.538e1e7c6643833d5ce3.png",
      url: "https://srirajalakshmitravels.in",
      telephone: "+91 90952 23243",
      address: {
        "@type": "PostalAddress",
        streetAddress: "12/4 Main Road",
        addressLocality: "Aruppukottai",
        addressRegion: "Tamil Nadu",
        postalCode: "626101",
        addressCountry: "IN"
      },
      openingHours: "Mo-Su 00:00-23:59",
      priceRange: "₹₹",
      sameAs: [
        "https://www.facebook.com/",
        "https://www.instagram.com/"
      ]
    })}
  </script>


  {/* ✅ Service Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: "Van Rental, Car Rental, Tourist Vehicle Booking",
      provider: {
        "@type": "TravelAgency",
        name: "Sri Rajalakshmi Travels",
      },
      areaServed: "Aruppukottai, Virudhunagar",
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Travel Services",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Van Rental in Aruppukottai",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Car Rental in Aruppukottai",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Tour Package Booking",
            },
          },
        ],
      },
    })}
  </script>


  {/* ✅ Review Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Review",
      itemReviewed: {
        "@type": "LocalBusiness",
        name: "Sri Rajalakshmi Travels",
        address: {
          "@type": "PostalAddress",
          streetAddress: "12/4 Main Road",
          addressLocality: "Aruppukottai",
          addressRegion: "Tamil Nadu",
          postalCode: "626101",
          addressCountry: "IN"
        },
      },
      reviewRating: {
        "@type": "Rating",
        ratingValue: "5"
      },
      author: {
        "@type": "Person",
        name: "Verified Customer"
      },
      reviewBody:
        "Best travels in Aruppukottai. Clean vans, polite driver and on-time pickup every time!"
    })}
  </script>

</Helmet>



      <Navbar />

      <section className="contact-section">

        <h1 className="contact-title" data-aos="fade-up">
          Contact Us
        </h1>

        <p className="contact-sub" data-aos="fade-up">
          We are available 24/7 — Reach us anytime for bookings & support
        </p>

        {/* CONTACT INFO */}
        <div className="contact-grid">

          <div className="contact-card" data-aos="slide-up">
            <h3>Phone Numbers</h3>
            <p>📞 +91 90952 23243</p>
            <p>📞 +91 89030 23243</p>
            
          </div>

          <div className="contact-card" data-aos="slide-up" data-aos-delay="150">
            <h3>Email Us</h3>
            <p>📧 srirajalakshmitravels@gmail.com</p>
           
          </div>

          <div className="contact-card" data-aos="slide-up" data-aos-delay="300">
            <h3>WhatsApp</h3>
            <a
              href="https://wa.me/919095223243"
              target="_blank"
              rel="noopener noreferrer"
              className="wa-btn"
            >
              💬 Chat on WhatsApp
            </a>
          </div>
        </div>

        {/* WHY CHOOSE US */}
        <div className="extra-info" data-aos="fade-up">
          <h2>Why Choose Us?</h2>
          <ul>
            <li>✔ 24/7 Travel Support</li>
            <li>✔ Safe & Comfortable Vehicles</li>
            <li>✔ Expert Drivers with 10+ Years Experience</li>
            <li>✔ Affordable Pricing — No hidden charges</li>
            <li>✔ Fast Pickup & On-Time Service</li>
          </ul>
        </div>

        {/* OFFICE ADDRESS */}
        <div className="office-box" data-aos="fade-up">
          <h2>Office Address</h2>
          <p>📍 Sri Rajalakshmi Travels</p>
          <p>12/4, Main Road, Aruppukottai</p>
          <p>Virudhunagar District, Tamil Nadu - 626101</p>
        </div>

        {/* MAP */}
        <div className="map-wrapper" data-aos="fade-up">
          <h2 className="map-title">Find Us on Map</h2>

          <iframe
            title="Aruppukottai Map"
            className="map-frame"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3938.806843133!2d78.0945!3d9.5042!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b00c41ba34fcb6d%3A0xdecf8797d0af3d0!2sAruppukottai!5e0!3m2!1sen!2sin!4v1669999999999"
            loading="lazy"
            allowFullScreen
          ></iframe>
        </div>

      </section>

      <Footer />
    </>
  );
}
